<script setup lang="ts">
import { UIButton, UIButtonLink } from '@groover-dev/groover-ui'

import { useIsOnCmsLandingPage } from '~/composables/useIsOnCMSLandingPage'

import { useBandSignupStore } from '~/stores/bandSignup'
import { useLoginStore } from '~/stores/login'

type Emits = {
  close: []
}

const emit = defineEmits<Emits>()

const { SET_DISPLAY: LOGIN_SET_DISPLAY } = useLoginStore()
const { SET_DISPLAY: BAND_SIGNUP_SET_DISPLAY } = useBandSignupStore()

const { isOnCmsLandingPage } = useIsOnCmsLandingPage()

const commonButtonProps = {
  theme: 'dark' as const,
  size: 'small' as const,
  color: 'neutral' as const,
  class: 'tw-whitespace-nowrap',
}

function handleLoginClick(): void {
  LOGIN_SET_DISPLAY(true)
  emit('close')
}

function handleSignupClick(): void {
  BAND_SIGNUP_SET_DISPLAY(true)
  emit('close')
}
</script>

<template>
  <div
    class="tw-grid tw-grid-flow-col tw-items-center tw-gap-lg tw-text-center"
  >
    <UIButtonLink
      v-if="!isOnCmsLandingPage"
      v-bind="commonButtonProps"
      data-test-id="curatorSignupLink"
      to="/influencer/signup/"
      no-prefetch
    >
      {{ $t('nav.mobile.loggedOut.becomeAPro') }}
    </UIButtonLink>
    <UIButtonLink
      data-test-id="loginLink"
      v-bind="commonButtonProps"
      class="tw-cursor-pointer tw-text-link-inverse"
      to="#"
      @click.prevent="handleLoginClick"
    >
      {{ $t('common.signIn') }}
    </UIButtonLink>
    <UIButton
      data-test-id="signupInitCTA"
      size="small"
      :text="$t('common.signUp')"
      @click="handleSignupClick"
    />
    <LazyInteractionLanguageSwitcherV2
      v-if="!isOnCmsLandingPage"
      dropdown-position="bottom"
      locale-verbosity="short"
      theme="dark"
      no-redirect
      :hydrate-on-interaction="['mouseenter', 'click']"
    />
  </div>
</template>
